// How the agency portal's screens call its functions.
//
// The same screens serve two people: the agency, through its link
// (/agency/:token), and AHFC staff looking at that agency's portal from
// inside CAERA (Schedule → Agency portal). `access` says which:
//
//   { token }     — the agency's link, sent in the body as it always was
//   { agencyId }  — a coordinator-and-above's own CAERA session, sent as the
//                   Authorization header; the function logs the view under
//                   their name, never as the agency (resolvePortalCaller)
//
// Staff views are read-only: the functions that act for the agency (submit a
// nurse, create a signing link) accept the link alone.
import { supabase } from './supabase';

const FN = (name) => `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/${name}`;

/** True when the screens are being viewed by AHFC staff, not the agency. */
export const isStaffView = (access) => !access?.token && !!access?.agencyId;

/** POST to a portal function as the agency or as staff. Returns the raw Response. */
export async function portalFetch(access, name, body = {}) {
  if (access?.token) {
    return fetch(FN(name), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body, token: access.token }),
    });
  }
  const { data: { session } } = await supabase.auth.getSession();
  return fetch(FN(name), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
      Authorization: `Bearer ${session?.access_token || ''}`,
    },
    body: JSON.stringify({ ...body, agencyId: access?.agencyId }),
  });
}
